import { colorsPalettes } from "@similarweb/styles";

import styled from "styled-components";

export const StyledWebsiteQueryBarContainer = styled.div`
    max-width: 1366px;
    margin: 0 auto;
    padding: 0px 43px;

    .compare-site-to-be-added > div,
    .querybar-item svg + span > div,
    .querybar-item svg + div {
        background-color: ${colorsPalettes.bluegrey[200]};
    }
`;
